@file:Suppress("EXPECT_ACTUAL_CLASSIFIERS_ARE_IN_BETA_WARNING")

package com.schoolconnect.app.util

import kotlinx.browser.window

actual object DebugPreview {
    actual fun featureId(): String = window.location.search
        .removePrefix("?")
        .split("&")
        .mapNotNull { part ->
            val pieces = part.split("=", limit = 2)
            if (pieces.size == 2 && pieces[0] == "preview") pieces[1] else null
        }
        .firstOrNull()
        .orEmpty()
}
